import AppointmentStatusSummaryMessage from './AppointmentStatusSummaryMessage';

export default AppointmentStatusSummaryMessage;
